// extracted by mini-css-extract-plugin
module.exports = {"blue":"Gradient_blue__2hBed","grey":"Gradient_grey__3YgNS"};